import React, { useState } from "react";

const Header = () => {
  const [buttonText, setButtonText] = useState("Connect Wallet");
  const changeText = (text) => setButtonText(text);

  return (
    <div className="row ml-0 ml-md-5 ">
      <div className="col-lg-6 col-12 order-2 order-lg-1">
        <h1>Sacrifice PAWN to make Kings.</h1>
        <div style={{ width: "40%" }}>
          <hr style={{ marginTop: "5px", borderTop: "1px solid black" }}></hr>
        </div>
      </div>
      <div
        style={{ textAlign: "right" }}
        className="col-lg-6 col-12 alignRight order-1 order-lg-2 mt-4 mt-md-0"
      >
        <a
          href="https://spookyswap.finance/swap?outputCurrency=0xd3b8037853785463D06957Fefa0f06Af53B9e504"
          className="buy-pawns mr-3"
        >
          Buy pawns
        </a>

        <a
          href="#"
          onClick={() => changeText("Address Values")}
          className="btn-connect-wallet"
        >
          {buttonText}
        </a>
      </div>
    </div>
  );
};

export default Header;
